<template>
<div class="hy-index2">
   <!--logo-->
  <div class="index_logo">
    <router-link to="/">
      <img :src="logoImg " alt="">
    </router-link>
  </div>
    <!--搜索-->
    <van-sticky>
      <div class="index-searchbox">
        <van-search v-model="searchValue" :clearable=false background="#FFF" placeholder="输入关键字，搜索讲座" @search="onSearch" />
        <div class="rightBtn" @click='onSearch'>
          <van-icon name="search" />
        </div>
       </div>
    </van-sticky>

  <!--banner-->
  <div class="index-bannerbox">
    <van-swipe class="my-swipe" :autoplay="5000">
      <van-swipe-item v-for="(item, index) in data.banner" :key="index">
        <img v-lazy="item.pic_url" @click="goPath(item.url)" />
      </van-swipe-item>
     </van-swipe>
  </div>
  <div class="index-list" v-if="data.hot_conference">
    <div class="rows">
      <h5 class="index-title">热门会议<span>HOT MEETINGS</span></h5>
      <van-list>
        <van-cell v-for="items in data.hot_conference" :key="items.id" v-if="data.hot_conference.length > 0">
          <a class="more-link" :href="'/index/conference/template?id='+items.id">
            <div class="imgbox">
              <img :src="items.cover_url" alt />
              <div class="typeFixed">
                <span>{{items.status_str }}</span> |
                <span class="type">{{items.type_str}}</span>
              </div>
            </div>
            <div class="textbox">
              <div class="title">
                <h5>{{items.name}}</h5>
              </div>
              <div class="textinfo">
                <span class="l"> {{items.province_name}}</span>
                <span class="r">{{items.form_str}}</span>
              </div>
              <div class="textinfo">
                {{items.start_time ,'Y年M月D日'|formatDates}}~ {{items.end_time ,'Y年M月D日'|formatDates}}
              </div>
            </div>
          </a>
        </van-cell>
      </van-list>
    </div>
  </div>

  <!--列表-->
  <div class="index-list">
    <div class="rows">
      <h5 class="index-title">全部会议 <span>ALL MEETINGS</span></h5>
      <div class="list_type">
        <div class="type_rows" v-for="items2 in data.navigation">
          <b>{{items2.name}}：</b>
          <div class="items_list">
            <template v-for="(items3,key,index) in items2.list">
              <router-link to="/">{{items3}}</router-link>
           </template>
          </div>
        </div>
      </div>
      <van-list>
        <van-cell v-for="items in data.conference_list" :key="items.id" v-if="data.conference_list.length > 0">
          <a class="more-link" :href="'/index/conference/template?id='+items.id">
            <div class="imgbox">
              <img :src="items.cover_url" alt />
              <div class="typeFixed">
                <span>{{items.status_str }}</span> |
                <span class="type">{{items.type_str}}</span>
              </div>
            </div>
            <div class="textbox">
              <div class="title">
                <h5>{{items.name}}</h5>
              </div>
              <div class="textinfo">
                <span class="l"> {{items.province_name}}</span>
                <span class="r">{{items.form_str}}</span>
              </div>
              <div class="textinfo">
                {{items.start_time ,'Y年M月D日'|formatDates}}~ {{items.end_time ,'Y年M月D日'|formatDates}}
              </div>
            </div>
          </a>
        </van-cell>
      </van-list>
      <div class="getMoreLink">
        <router-link to="/">查看更多<span class="iconfont">&#xe633;&#xe633;&#xe633;</span></router-link>
      </div>
    </div>
  </div>

  <!--专题列表-->
  <div class="zhuanti-list">
    <div class="rows">
      <h5 class="index-title">会议专题</h5>
      <div class="zhuanti_list">
        <div class="items" v-for="items in data.subject">
          <a :href="'/index/conference/template?id='+items.id">
            <img :src="items.cover_url" alt />
          </a>
        </div>
      </div>
    </div>
  </div>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <router-link class="iconfont fixed-link" to="/myEnroll">&#xe609;</router-link>
    </div>
  </div>
</template>


<script>
  import {
    formatDates
  } from "../assets/js/date";
  export default {
    data() {
      return {
        logoImg:require('../assets/images/2.0/mlogo_2.0.png'),
        imagesList: [
         /* {
            imgUrl:require('../assets/images/2.0/banner2.0.jpg'),
            path:''
          },
          {
            imgUrl:require('../assets/images/2.0/banner2.0.jpg'),
            path:''
          }*/
        ],
        bannerdata: [],
        searchValue: "",
        /* 全部会议信息 */
        data: [],
      };
    },
    created() {
      var _this = this;
      this.list();
      _this.$WXConfig.wxShowMenu({
        ifshare: true,
        that: _this,
        data: ''
      });
    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      //banner跳转方法
      goPath(path) {
        if (path == "") {
          return false;
        }
        // this.$router.push(path);
        window.location.href = path;
      },
      //搜索方法
      onSearch() {
        let _this = this;
        if (_this.searchValue != "") {
          this.$router.push({
            path: `/Search2?text=`+_this.searchValue
          });
        } else {
          this.$toast('请输入搜索内容');
        }
      },
      /* 初始化数据列表 */
      list() {
        var _this = this;
        let url = "/ac1/conference/index2";
        let params = {};
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.data = res.posts;
          }
        });
      }
    }
  };
</script>
<style lang="less" scoped>
</style>
